module.exports = __webpack_public_path__ + "img/time.bac47aa2.svg";